import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X, Sparkles } from "lucide-react";

// Rotating CTAs — discreet floating bottom-right dock, premium aesthetic
const ROTATING_CTAS = [
  { l: "Publiez votre activité dans GAI", a: "Publier mon activité" },
  { l: "Annoncez dans notre prochaine édition", a: "Réserver mon espace" },
  { l: "Boostez votre visibilité", a: "Découvrir nos formats" },
  { l: "Réservez votre espace média", a: "Réserver maintenant" },
  { l: "Devenez partenaire média", a: "Devenir partenaire" },
];

export default function FloatingAdCTA() {
  const [idx, setIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem("gai_float_cta_dismissed_v1")) {
      setDismissed(true);
      return;
    }
    const t = setInterval(() => setIdx((i) => (i + 1) % ROTATING_CTAS.length), 5000);
    return () => clearInterval(t);
  }, []);

  if (dismissed) return null;
  const current = ROTATING_CTAS[idx];

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem("gai_float_cta_dismissed_v1", "1"); } catch { /* noop */ }
  };

  return (
    <div
      className="fixed right-6 z-[60] hidden md:flex items-stretch shadow-2xl gai-fade-up"
      style={{
        bottom: "76px",
        background: "var(--gai-black)",
        border: "1px solid var(--gai-charcoal)",
        boxShadow: "0 24px 60px -20px rgba(0,0,0,0.45)",
        maxWidth: "440px",
      }}
      data-testid="floating-ad-cta"
    >
      <div
        className="shrink-0 flex items-center justify-center px-4"
        style={{ background: "var(--gai-red)", color: "var(--gai-white)" }}
      >
        <Megaphone size={18} />
      </div>

      <div className="px-5 py-3 flex flex-col gap-1 min-w-0 flex-1">
        <div className="text-[0.6rem] font-bold tracking-[0.24em] uppercase flex items-center gap-1.5" style={{ color: "var(--gai-red)" }}>
          <Sparkles size={10} /> Espace annonceurs
        </div>
        <div
          key={idx}
          className="serif leading-snug gai-fade-up text-sm md:text-base"
          style={{ color: "var(--gai-white)", fontFamily: "'Playfair Display', serif" }}
          data-testid="floating-cta-headline"
        >
          {current.l}
        </div>
        <Link
          to="/annoncer"
          className="mt-1 inline-flex items-center gap-1 text-[0.68rem] font-semibold tracking-[0.18em] uppercase self-start hover:opacity-80"
          style={{ color: "var(--gai-red)" }}
          data-testid="floating-cta-link"
        >
          {current.a} →
        </Link>
      </div>

      <button
        onClick={dismiss}
        className="shrink-0 px-2 py-2 hover:opacity-80"
        style={{ color: "rgba(255,255,255,0.5)" }}
        aria-label="Fermer"
        data-testid="floating-cta-close"
      >
        <X size={14} />
      </button>
    </div>
  );
}
